import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { AdminPropertyAd, i18nLocationName } from 'types'
import { useAuthStore } from 'store'
import { PropertyAttributeEnum } from 'types/enums'

interface Props {
  propertyAd: AdminPropertyAd
}

function ListingDescription(props: Props) {
  const { propertyAd } = props

  const { t } = useTranslation()

  const locale = useAuthStore((state) => state.locale)

  const LOCALISED_LOCATION_NAME = React.useMemo(() => {
    return propertyAd?.properties?.[0]?.location?.searchLocation?.i18nLocationName?.find(
      (item) => item.locale === locale
    ) as i18nLocationName
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale])

  const PROPERTY_TYPE = React.useMemo(() => {
    return propertyAd?.properties?.[0]?.propertyAttributes?.find((item) =>
      [1, 4].includes(propertyAd.adCategory.id)
        ? item.type.description === PropertyAttributeEnum.ESTATE_PROPERTY_TYPE
        : [2, 5].includes(propertyAd.adCategory.id)
        ? item.type.description ===
          PropertyAttributeEnum.ESTATE_PROPERTY_COMMERCIAL_TYPE
        : item.type.description ===
          PropertyAttributeEnum.ESTATE_PROPERTY_LAND_TYPE
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      <Box sx={{ flexGrow: 1, minWidth: '350px' }}>
        <Box
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '16px',
          }}
        >
          {`${t(
            `enums.${PROPERTY_TYPE?.type.description}.${PROPERTY_TYPE?.valueText}.base`
          )} ${
            propertyAd.properties?.[0]?.squareMeters
              ? t('generics.area', {
                  count: Number(
                    propertyAd?.properties?.[0]?.squareMeters.toFixed(2)
                  ),
                })
              : '-'
          }`}
        </Box>
        <Box
          sx={{
            mt: '5px',
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '16px',
          }}
        >
          {LOCALISED_LOCATION_NAME?.locationPath?.replaceAll('/', ',')}
        </Box>
      </Box>
      <Box sx={{ flexGrow: 0.5 }}>
        <Box
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '16px',
          }}
        >
          <Box>
            {`${
              propertyAd.salesPrice
                ? t('generics.currency', {
                    count: Number(propertyAd.salesPrice.toFixed(2)),
                  })
                : '-'
            }`}
          </Box>

          <Box sx={{ mt: '5px' }}>
            {`${
              propertyAd.salesPricePerSqrMeter &&
              propertyAd.salesPricePerSqrMeter > 10
                ? t('generics.priceToArea', {
                    count: Math.trunc(Number(propertyAd.salesPricePerSqrMeter)),
                  })
                : propertyAd.salesPricePerSqrMeter &&
                  propertyAd.salesPricePerSqrMeter < 10
                ? t('generics.priceToArea', {
                    count: Number(propertyAd.salesPricePerSqrMeter.toFixed(2)),
                  })
                : '-'
            }`}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ListingDescription
